import { roundToScale } from '@/shared'

export const roundCents = <T extends number|null|undefined>(value: T) => roundToScale(value, 2)
